import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ErrorWrapper } from '@interfaces/error-wrapper.interface';

@Injectable()
export class ErrorModalService {

  private errorRequestsStream$ = new BehaviorSubject<ErrorWrapper>(null);

  showErrorModal(errorWrapper: ErrorWrapper) {
    this.errorRequestsStream$.next(errorWrapper);
  }

  hideErrorModal() {
    this.errorRequestsStream$.next(null);
  }

  getErrorStream(): Observable<ErrorWrapper> {
    return this.errorRequestsStream$.asObservable();
  }
}
